<nb-card>

    <nb-card-body style="overflow-x: hidden;">

        <ngx-patient-calendar #patientCalendarComponent [isClientView]="false" [patient]="patient"></ngx-patient-calendar>


    </nb-card-body>

</nb-card>
